import { getFunctions, httpsCallable } from "firebase/functions";
import { log } from "../../helper/helper";
import config from "./../../config.json";
import { getApp } from "firebase/app";

export function adminFindRider(email, birth) {
    let data = {
        email_address: email,
        birth_date: birth,
    };

    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const adminFindRider = httpsCallable(functions, config.adminFindRiderForRTWS);
    return adminFindRider(data);
}
export function adminRiderDocumentManualReviewVerifyRTW(uid, isAustralianCitizen, visaGrantDate, isIssuedWithUnlimitedWorkRight, visaExpiryDate, allowedWorkingHoursPerEeek, visaSubclass, visaConditionsNote, codeOne, codeTwo, fileURL, rightWorkIssueDate) {
    let data = {
        rider_uid: uid,
        is_australian_citizen: isAustralianCitizen,
        visa_grant_date: visaGrantDate,
        is_issued_with_unlimited_work_right: isIssuedWithUnlimitedWorkRight,
        visa_expiry_date: visaExpiryDate,
        allowed_working_hours_per_week: allowedWorkingHoursPerEeek,
        visa_subclass: visaSubclass,
        visa_conditions_note: visaConditionsNote,
        right_to_work_verification_code_1: codeOne,
        right_to_work_verification_code_2: codeTwo,
        right_to_work_file_url: fileURL,
        right_to_work_issue_date: rightWorkIssueDate,

    };
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const adminRiderDocumentManualReviewVerify = httpsCallable(functions, config.adminRiderDocumentManualReviewVerifyRTW);
    return adminRiderDocumentManualReviewVerify(data);
}



